// @/utils/lazyLib.js
const cache = {
  echarts: null,
  html2canvas: null,
  echartsWordcloudLoaded: false
}

let echartsPromise = null
let h2cPromise = null
let wordCloudPromise = null

export function loadEcharts() {
  if (cache.echarts) {
    return Promise.resolve(cache.echarts)
  }
  if (!echartsPromise) {
    echartsPromise = import('echarts').then(mod => {
      cache.echarts = mod.default || mod
      window.echarts = cache.echarts
      return cache.echarts
    })
  }
  return echartsPromise
}

// 新增：加载词云插件，必须等echarts加载完
export async function loadEchartsWordcloud() {
  if (cache.echartsWordcloudLoaded) return Promise.resolve()
  if (!wordCloudPromise) {
    // 先等echarts就绪，再加载插件
    wordCloudPromise = loadEcharts().then(() => import('echarts-wordcloud'))
  }
  await wordCloudPromise
  cache.echartsWordcloudLoaded = true
}

export function loadHtml2Canvas() {
  if (cache.html2canvas) {
    return Promise.resolve(cache.html2canvas)
  }
  if (!h2cPromise) {
    h2cPromise = import('html2canvas').then(mod => {
      cache.html2canvas = mod.default
      window.html2canvas = cache.html2canvas
      return cache.html2canvas
    })
  }
  return h2cPromise
}

// 空闲预加载入口
export function preloadAll() {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      loadEcharts()
      loadHtml2Canvas()
    }, { timeout: 2000 })
  } else {
    setTimeout(() => {
      loadEcharts()
      loadHtml2Canvas()
    }, 1000)
  }
}
